import { service } from '@ember/service';
import type { ValidatorMap } from 'ember-changeset/types';
import type { IntlService } from 'ember-intl';
import CrudJournalEventBaseComponent from 'parog-web/components/forc/abstract/crud-journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import JournalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import TemperatureMeasuredJournalEvent from 'parog-web/models/temperature-measured-journal-event';
import type SemeiaSessionService from 'parog-web/services/session';
import formatNumberAsString from 'parog-web/utils/format-number-as-string';

export default class TemperatureEditionFormComponent extends CrudJournalEventBaseComponent<TemperatureMeasuredJournalEvent> {
  static override forcDisplayName = 'Mesure de la température';
  static override fullComponentId = 'temperature/edition-form';
  static override journalEventClass = TemperatureMeasuredJournalEvent;

  @service declare intl: IntlService;
  @service declare session: SemeiaSessionService;

  override retrieveJournalEvent =
    JournalEventRetrievalStrategies.sourceJournalEvent;

  override get toastMessage() {
    return this.session.patient
      ? {
          message: 'Votre mesure a bien été prise en compte.',
          title: 'Température'
        }
      : super.toastMessage;
  }

  override get validations(): ValidatorMap {
    return this.journalEventClass.validations(this.intl);
  }

  override async save(): Promise<void> {
    this.changeset.set(
      'temperature',
      formatNumberAsString(this.changeset.get('temperature'))
    );

    await super.save();
    this.analytics.trackPatientMeasurement('temperature');
  }

  <template>
    <Provider @forcComponent={{this}}>
      <:content as |Form|>
        <div class='two fields'>
          <div class='field'>
            <Form.Date
              @labelName='Date de la mesure'
              @propertyName='occurredAt'
            />
          </div>
          <div class='field'>
            <Form.NumberInput
              @labelName='Température (°C)'
              @propertyName='temperature'
            />
          </div>
        </div>
        <div class='field'>
          <Form.TextArea @labelName='Commentaires' @propertyName='comments' />
        </div>
      </:content>
    </Provider>
  </template>
}
